export function CoreHTTPConfig ($httpProvider) {
  $httpProvider.interceptors.push(function ($rootScope, $q) {
    return {
      request: function (config) {
        $rootScope.waiting = true;
        return config;
      },
      response: function (config) {
        $rootScope.waiting = false;
        return config;
      },
      responseError: function (response) {
        $rootScope.errorStatusCode = response.status;
        $rootScope.waiting = false;

        return $q.reject(response);
      }
    }
  })
}